module.exports = __webpack_public_path__ + "static/py-9b51074b5fe4add290d14a3b2408d5e7.svg";